import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Chip, Grid, IconButton } from "@mui/material";
import { ImagePreview } from "../posts/Photos/PhotoUploader";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import { alertService, setBackdrop, useAsyncDeleteAction, BtnLoad } from "common-frontend-components";
import { timeSince } from 'common-frontend-components';
import { postCardStyle, textFieldStyle } from "../../../assets/styles/styles";
import { textColor } from "../../../assets/styles/colors";
import EditIcon from '@mui/icons-material/Edit';
import { sitePhotoGroupStore } from "../../../stores/appConfig/sitePhotoGroupStore";
import { JsonInput } from "./JSONEditorReact";
import { callDeleteSitePhotoAsync, callDeleteSitePhotoGroupsAsync, callInitSitePhotoDeleteAsync } from "../../../apis/sitePhotos";
import { sitePhotoStore } from "../../../stores/appConfig/sitePhotoStore";
import { EditSitePhoto } from "./EditSitePhoto";
const onDeletePhoto = (item) => {
    if (!item.key)
        return;
    return callInitSitePhotoDeleteAsync(item.key).then(() => {
        item.key = undefined;
        item.url = undefined;
        sitePhotoStore.setData([item, ...sitePhotoStore.getData().filter(i => i.id !== item.id)]);
    });
};
export const createOnDelete = (item) => async () => {
    const response = {
        error: undefined,
    };
    setBackdrop(true);
    try {
        await onDeletePhoto(item);
        const groups = sitePhotoGroupStore.getGroupsBySitePhotoId(item.id);
        await callDeleteSitePhotoGroupsAsync(item.id);
        const groupMap = sitePhotoGroupStore.getData().reduce((map, i) => (map[i.id] = i, map), {});
        groups.forEach(i => delete groupMap[i.id]);
        sitePhotoGroupStore.setData(Object.values(groupMap));
        await callDeleteSitePhotoAsync(item.id);
        sitePhotoStore.setData(sitePhotoStore.getData().filter(i => item.id !== i.id));
    }
    catch (e) {
        response.error = e;
        alertService.error(e);
    }
    finally {
        setBackdrop(false);
    }
    return response;
};
const DeleteAppConfigItem = ({ item }) => {
    const { handleClick, isSubmitting } = useAsyncDeleteAction({
        name: 'app config item',
        value: item.path,
        onClick: createOnDelete(item)
    });
    return (_jsx(Button, { size: "small", onClick: handleClick, children: _jsx(BtnLoad, { loading: isSubmitting, text: "Delete", loadText: "Deleting" }, void 0) }, void 0));
};
export const SitePhotoCard = ({ item }) => {
    const groups = sitePhotoGroupStore.useGroupsBySitePhotoId(item.id);
    const [isEdit, setIsEdit] = useState(false);
    if (isEdit) {
        const onClose = () => setIsEdit(false);
        const onChange = (p) => {
            sitePhotoStore.setData(sitePhotoStore.getData().map(i => {
                if (i.id === p.id)
                    return p;
                return i;
            }));
        };
        return (_jsx(EditSitePhoto, { sitePhoto: item, onCancel: onClose, groups: groups.map(i => i.group), onSuccess: onClose, onUpdate: onChange }, void 0));
    }
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsxs(Grid, { container: true, alignItems: "flex-start", children: [_jsxs(Typography, { sx: { fontSize: '1.5rem', fontWeight: 600, paddingBottom: 1, color: textColor }, color: "text.secondary", gutterBottom: true, children: [item.path, _jsx(Box, { sx: { fontSize: '.85rem', fontWeight: 300, color: textColor + '55' }, children: timeSince(new Date(item.created)) }, void 0)] }, void 0), _jsx(Box, { sx: { flexGrow: 1 } }, void 0), _jsx(IconButton, { color: 'info', onClick: () => setIsEdit(true), children: _jsx(EditIcon, {}, void 0) }, void 0)] }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [item.url ?
                                    _jsxs(Grid, { item: true, xs: 12, children: [_jsx(ImagePreview, { photos: [{ url: item.url }], index: 0 }, void 0), item.photoLastModified ?
                                                _jsxs(Typography, { sx: { fontSize: '.85rem', fontWeight: 300, color: textColor + '55' }, color: "text.secondary", gutterBottom: true, children: ["Last Modified: ", timeSince(new Date(item.photoLastModified))] }, void 0)
                                                : null] }, void 0)
                                    : null, item.params ?
                                    _jsx(Grid, { item: true, xs: 12, children: _jsx(JsonInput, { boxProps: { sx: { width: '100%', height: 300 } }, value: item.params }, void 0) }, void 0)
                                    : null] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsxs(Grid, { container: true, spacing: 1, children: [groups.map(i => _jsx(Grid, { item: true, children: _jsx(Chip, { label: i.group, sx: { ...textFieldStyle, backgroundColor: '#ffffff33' } }, void 0) }, i.id)), _jsx(Grid, { item: true, children: _jsx("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: _jsx(DeleteAppConfigItem, { item: item }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=SitePhotoCard.js.map